// extracted by mini-css-extract-plugin
export default {"content":"zrTuz","group":"jVhRR","disable":"tu0mg","checkboxGroup":"JMlT1","switch":"uiBNH","switchGroup":"N4z8g"};